import * as React from 'react'

export const DeleteIcon = props => (
  <svg
    width={28}
    height={28}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m12 12 12 12M24 12l-12 12"
      stroke="#1F2D27"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2px"
    />
  </svg>
)
